export function addOne(index: number) {
  return index + 1;
}
